import React from 'react';

export function ReviewSidebar({
  score,
  totalQuestions,
  currentLevel,
  questions,
  currentQuestionIndex,
  onQuestionSelect,
  soalsStats = [],
  soalStatsById = {},
}) {
  const currentLevelInt = Math.floor(currentLevel);
  const progress = (currentLevel - currentLevelInt) * 100;

  const getQuestionAccuracy = (question) => {
    if (question.accuracy !== undefined && question.accuracy !== null) {
      return Math.round(question.accuracy * 100);
    }
    if (question.matchedSoalStat && typeof question.matchedSoalStat.accuracy === 'number') {
      return question.matchedSoalStat.accuracy;
    }
    return question.isCorrect ? 100 : 0;
  };

  const getSessionAccuracy = (question) => {
    if (question.matchedSoalStat) {
      if (question.matchedSoalStat['session-accuracy'] !== undefined && question.matchedSoalStat['session-accuracy'] !== null) {
        return question.matchedSoalStat['session-accuracy'];
      }
      if (question.matchedSoalStat.accuracy !== undefined && question.matchedSoalStat.accuracy !== null) {
        return question.matchedSoalStat.accuracy;
      }
    }
    return null;
  };

  return (
    <div className="hidden xl:flex w-80 shrink-0 self-start flex-col bg-[var(--card-bg)] p-6 gap-6 rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.1)] dark:shadow-[0_4px_20px_rgba(0,0,0,0.3)] dark:border dark:border-white/[0.06] [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:bg-black/5 [&::-webkit-scrollbar-track]:rounded [&::-webkit-scrollbar-thumb]:bg-[rgba(20,110,105,0.3)] [&::-webkit-scrollbar-thumb]:rounded hover:[&::-webkit-scrollbar-thumb]:bg-[rgba(20,110,105,0.5)]">
      <div className="flex flex-col gap-6">
        <div className="text-center p-5 rounded-xl bg-gradient-to-br from-[#e8f5f4] to-[#d4ebe9] dark:from-teal-500/10 dark:to-teal-500/5">
          <div className="text-sm font-semibold text-[#146e69] dark:text-[#2dd4bf] mb-2">Score</div>
          <div className="text-5xl font-bold text-[#146e69] dark:text-[#2dd4bf] leading-none">{score}</div>
        </div>

        <div className="p-4 rounded-xl bg-[rgba(20,110,105,0.05)] dark:bg-[rgba(20,110,105,0.08)] border-2 border-[rgba(20,110,105,0.1)] dark:border-[rgba(20,110,105,0.2)]">
          <div className="text-sm font-bold text-[var(--accent-teal)] mb-3">Level {currentLevelInt}:</div>
          <div className="w-full h-6 bg-[rgba(20,110,105,0.1)] dark:bg-slate-400/15 rounded-xl overflow-hidden mb-2 relative">
            <div
              className="h-full bg-gradient-to-r from-[#2a9d8f] to-[#146e69] transition-[width] duration-300 ease-out rounded-xl relative after:content-[''] after:absolute after:inset-0 after:bg-gradient-to-r after:from-transparent after:via-white/30 after:to-transparent"
              style={{ width: `${progress}%` }}
            />
          </div>
          <div className="text-xs font-semibold text-[var(--accent-teal)] text-right">
            {Math.round(progress)} / 100
          </div>
        </div>

        <div className="flex flex-col gap-2">
          {questions.map((question, index) => {
            const accuracy = getQuestionAccuracy(question);
            const sessionAccuracy = getSessionAccuracy(question);
            const isCorrect = accuracy >= 80;
            const isCorrectMobile =
              sessionAccuracy !== null && sessionAccuracy !== undefined
                ? sessionAccuracy >= 80
                : isCorrect;
            const isActive = index === currentQuestionIndex;

            const navItemBase =
              'flex justify-center items-center py-3.5 px-4 bg-[var(--card-bg)] border-2 border-[var(--border-color)] rounded-lg cursor-pointer transition-all duration-200 text-sm font-medium text-[var(--text-primary)] relative hover:bg-[var(--bg-hover)] hover:border-[#146e69]';
            const navItemActive = isActive
              ? 'bg-[rgba(20,110,105,0.1)] border-[#146e69] font-semibold'
              : '';
            const navItemCorrect = isCorrect ? 'border-l-4 border-l-emerald-500' : 'border-l-4 border-l-red-500';

            return (
              <div key={index} className="contents">
                <button
                  type="button"
                  className={`${navItemBase} ${navItemActive} ${navItemCorrect}`}
                  onClick={() => onQuestionSelect(index)}
                >
                  <span className="flex-1 text-center">
                    <span className="block">Question {index + 1}</span>
                  </span>
                  <span className="font-bold text-[#146e69] dark:text-[#2dd4bf] text-sm absolute right-4">
                    {accuracy !== null && accuracy !== undefined ? accuracy : '--'}
                  </span>
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
